$(document).on('turbolinks:load', () => {
  $('.b-modal-alert form').on('submit', e => {
    $(e.currentTarget)
      .find('.b-input-v4.agreement-confirmation, .b-input-v4.privacy-consent')
      .each((_index, warpperNode) => {
        const $checkbox = $(warpperNode).find('input[type=checkbox]');
        if (!$checkbox.length || $checkbox.is(':checked')) { return; }

        e.preventDefault();
        e.stopImmediatePropagation();

        warpperNode.classList.add('field_with_errors');
        $checkbox.one('change', () => warpperNode.classList.remove('field_with_errors'));
      });
  });
});
